module.exports = __webpack_public_path__ + "img/discover1.1d4ff1b2.png";